import React from "react";
import LegalMarkdownPage from "./LegalMarkdownPage";

import cookieEnglish from "../docs/cookie-policy/cookie.en.md";
import cookieFrench from "../docs/cookie-policy/cookie.fr.md";
import cookieArabic from "../docs/cookie-policy/cookie.ar.md";
import cookieSpanish from "../docs/cookie-policy/cookie.es.md";
import cookieItalian from "../docs/cookie-policy/cookie.it.md";

import "../styles/LegalPages.css";

const cookieDocuments = {
  en: cookieEnglish,
  fr: cookieFrench,
  ar: cookieArabic,
  es: cookieEnglish, // no Spanish market yet, English reference version
  it: cookieEnglish, // no Italian market yet, English reference version
};

const CookiePolicy = () => {
  return (
    <LegalMarkdownPage
      documents={cookieDocuments}
      containerClassName="legal-page-container"
      headingClassName="legal-page-heading"
      errorMessage="The Cookie Policy could not be loaded."
    />
  );
};

export default CookiePolicy;
